// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY
import * as React from "react";
import CaretDownOutlinedSvg from "@ant-design/icons-svg/lib/asn/CaretDownOutlined";
import AntdIcon from "../components/AntdIcon";
const CaretDownOutlined = (props, ref)=>/*#__PURE__*/ React.createElement(AntdIcon, {
        ...props,
        ref: ref,
        icon: CaretDownOutlinedSvg
    });
if (process.env.NODE_ENV !== "production") {
    CaretDownOutlined.displayName = "CaretDownOutlined";
}
export default /*#__PURE__*/ React.forwardRef(CaretDownOutlined);
